<template>
  <div>
    <images-dialog ref="imagesDialog" @submit="dialogSubmitted" />
    <image-edit-dialog
      ref="imageEditDialog"
      :key="value"
      @formSubmitted="fetchSelectedImage"
      :only-show-short-crop="onlyShowShortCrop"
      :only-show-small-crop="onlyShowSmallCrop"
      :only-show-normal-crop="onlyShowNormalCrop"
    />
    <div class="box">
      <img
        v-if="selectedImage"
        class="thumbnail"
        :src="src"
        :alt="selectedImage.title"
      />
      <div class="image-info">
        <p class="image-info__title" v-if="selectedImage">
          {{ selectedImage.title }}
          <i
            class="image-info__edit-image-icon fa fa-edit"
            @click="openEditImageDialog"
          />
        </p>
        <el-button @click="openDialog" type="info" class="open-dialog-button">
          <i class="fa fa-file-image-o"></i> Select or upload image
        </el-button>
      </div>
      <el-button
        @click.stop="removeImage"
        class="remove-button"
        v-if="value"
        size="mini"
        icon="el-icon-delete"
        type="danger"
        title="Delete image"
      >
      </el-button>
    </div>
  </div>
</template>
<script>
import ImagesDialog from '@/components/inputs/ImageDialog/'
import ImageEditDialog from '@/components/inputs/ImageDialog/ImageEditDialog'
import { Image } from '@/api'

export default {
  props: {
    value: {},
    onlyShowNormalCrop: {
      default: false
    },
    onlyShowShortCrop: {
      default: false
    },
    onlyShowSmallCrop: {
      default: false
    },
    defaultThumbnail: {
      default: false
    },
    specificThumbnail: {}
  },
  components: {
    ImagesDialog,
    ImageEditDialog
  },
  data() {
    return {
      selectedImage: null
    }
  },
  methods: {
    removeImage() {
      this.$emit('input', null)
    },
    openDialog() {
      this.$refs.imagesDialog.openDialog()
    },
    dialogSubmitted(image) {
      this.$emit('input', image)
    },
    fetchSelectedImage() {
      Image.get({ id: this.value }).then(response => {
        this.selectedImage = response.data
      })
    },
    openEditImageDialog() {
      this.$refs.imageEditDialog.openDialog(this.value)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        value ? this.fetchSelectedImage() : (this.selectedImage = null)
      }
    }
  },
  computed: {
    src() {
      let thumbnail
      if (this.defaultThumbnail) {
        thumbnail = this.selectedImage.thumbnail
          ? this.selectedImage.thumbnail.url
          : this.selectedImage.file_url
      } else if (this.specyficThumbnail) {
        thumbnail = this.selectedImage[`${this.specyficThumbnail}_crop`]
          ? this.selectedImage[`${this.specyficThumbnail}_crop`].file
          : null
      } else {
        if (this.onlyShowNormalCrop && this.selectedImage.normal_crop) {
          thumbnail = this.selectedImage.normal_crop.file
        } else if (this.onlyShowShortCrop && this.selectedImage.short_crop) {
          thumbnail = this.selectedImage.short_crop.file
        } else if (this.onlyShowSmallCrop && this.selectedImage.small_crop) {
          thumbnail = this.selectedImage.small_crop.file
        }
      }
      if (!thumbnail) {
        thumbnail = this.selectedImage.thumbnail
          ? this.selectedImage.thumbnail.url
          : this.selectedImage.file_url
      }
      return thumbnail
    }
  }
}
</script>
<style lang="scss" scoped>
.remove-button {
  position: absolute;
  right: 28px;
  top: 28px;
}

.open-dialog-button {
  vertical-align: middle;
}

.thumbnail {
  max-width: 140px;
  vertical-align: middle;
}

.image-info {
  display: inline-block;
  vertical-align: middle;
  margin-left: 20px;

  &__title {
    font-weight: 700;
  }

  &__edit-image-icon {
    cursor: pointer;
    vertical-align: middle;
  }
}
</style>
